import { createContext } from '@lit/context';
import { LearnerProgressionClient } from '../clients/learner-progression-client';

export const learnerProgressionClientContext = createContext<LearnerProgressionClient>(
  Symbol('learner-progression-client')
);
